import React, { useEffect } from 'react'
import { LanguageProvider as BaseLanguageProvider, useLanguage, type Language } from '@innolab-trader/translations'
import { StorageEngine } from '@innolab-trader/storage'

export function PersistentLanguageProvider({ children }: { children: React.ReactNode }) {
  return (
    <BaseLanguageProvider>
      <LanguagePersistor />
      {children}
    </BaseLanguageProvider>
  )
}

function LanguagePersistor() {
  const { language, setLanguage } = useLanguage()
  const storageKey = 'innolab-trader-language'

  // On mount, load stored language and override
  useEffect(() => {
    (async () => {
      try {
        const doc = StorageEngine.local().document<string>(storageKey)
        const stored = await doc.load()
        if (stored) setLanguage(stored as Language)
      } catch {}
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Persist language changes
  useEffect(() => {
    (async () => {
      try { await StorageEngine.local().document<string>(storageKey).save(language) } catch {}
    })()
  }, [language])

  return null
}

export { useLanguage } from '@innolab-trader/translations'
